// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 3009) return "static/chunks/aad4249a-6488803a6a70c3bd.js";
	if (chunkId === 4221) return "static/chunks/4221-d66ee66ccef75e2d.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1346":"8ea2dee116b98840","1838":"9f2f16befeb1160f","6985":"eaedfc54eb7aa174"}[chunkId] + ".js";
};